import { useTranslation } from "react-i18next";
import { Step } from "react-joyride";
import { useSearchParams } from "react-router-dom";

export function useJoyrideSteps(): Step[] {
  const { t } = useTranslation();

  return [
    {
      target: '[data-tour="step-1"]',
      title: t("label.titleStep1"),
      content: t("label.step1Content"),
      hideCloseButton: true,
      disableOverlayClose: true,
      disableScrollParentFix: true,
      disableScrolling: true,
      isFixed: true,
      offset: 0,
      placement: "center",
      disableBeacon: true,
      spotlightClicks: false,
      spotlightPadding: 5,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
    },
    {
      target: '[data-tour="step-2"]',
      title: t("label.step2Title"),
      content: t("label.step2Content"),
      hideCloseButton: true,
      disableOverlayClose: true,
      disableBeacon: true,
      placement: "left",
      spotlightClicks: false,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
    },
    {
      target: '[data-tour="step-3"]',
      title: t("label.step3Title"),
      content: t("label.step3Content"),
      hideCloseButton: true,
      placement: "left",
      disableOverlayClose: true,
      disableBeacon: true,
      spotlightClicks: false,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
    },
    {
      target: ".total-score-grid",
      title: t("label.step4Title"),
      content: t("label.step4Content"),
      hideCloseButton: true,
      placement: "bottom",
      disableOverlayClose: true,
      disableBeacon: true,
      spotlightClicks: false,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
    },
    {
      target: '[data-tour="step-5"]',
      title: t("label.step5Title"),
      content: t("label.step5Content"),
      hideCloseButton: true,
      placement: "left",
      disableOverlayClose: true,
      // offset: 200,
      disableBeacon: true,
      spotlightClicks: false,
      spotlightPadding: 4,

      styles: {
        options: {
          zIndex: 10000,
        },
      },
    },
  ];
}

export function useIsJoyrideEnabled() {
  const [params] = useSearchParams();
  const isJoyrideEnabled = params.get("joyride") === "true";
  return isJoyrideEnabled;
}
